import { TIMEZONE_LIST } from "const/timezoneList"

export function getCountryList() {
  const seen = new Set();
  const result = [];

  for (const item of TIMEZONE_LIST) {
    if (!seen.has(item.countryIndex)) {
      seen.add(item.countryIndex);
      result.push({
        label: item.name,
        value: item.countryIndex,
      });
    }
  }

  return result;
}

export function getTimezoneList(countryIndex) {
  return TIMEZONE_LIST
    .filter(item => item.countryIndex === countryIndex)
    .map(item => {
      const hasDST = item.dsts.includes(",") ? ", DST" : "";
      return {
        label: `(UTC${item.timezone}) ${item.zone}${hasDST}`,
        value: item.zone,
      };
    });
}
